import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";
import { ApacUiComponent } from "../../context";
import { useApacUiStyles } from "../../hooks";
import defaultStyles from "./PriceDotIndicator.module.scss";

interface PriceDotIndicatorProps {
  priceBucket: number;
  className?: string;
  symbol?: React.ReactNode;
}

export const PriceDotIndicator = ({
  priceBucket: index,
  className,
  symbol,
}: PriceDotIndicatorProps): JSX.Element => {
  const styles = useApacUiStyles(
    ApacUiComponent.PriceDotIndicator,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(styles, ApacUiComponent.PriceDotIndicator);

  return (
    <div
      className={clsx(block, className)}
      style={{
        color: `var(--bucket-${index}-dot-color)`,
      }}
    >
      {Array.from({ length: index + 1 }, (_) =>
        symbol ? symbol : <div className={cn("dot")} />
      )}
    </div>
  );
};
